import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  ClosedRangeSerializer28fgvycwrq3dm as ClosedRangeSerializer,
  UUIDSerializer_getInstance2ms0oa88en0c as UUIDSerializer_getInstance,
  InstantIso8601Serializer_getInstance2pw1uiz054ejd as InstantIso8601Serializer_getInstance,
  LocalDateIso8601Serializer_getInstance3gidjo5oele30 as LocalDateIso8601Serializer_getInstance,
  LocalTimeIso8601Serializer_getInstanceywsvdjhmwgt0 as LocalTimeIso8601Serializer_getInstance,
  LocalDateTimeIso8601Serializer_getInstance302qwxjrznnmc as LocalDateTimeIso8601Serializer_getInstance,
  DurationSerializer_getInstance3b3q4n80uazai as DurationSerializer_getInstance,
} from './Serializers.mjs';
import { SerializersModuleBuilderfxsfdohcdipc as SerializersModuleBuilder } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { LocalTime22kisvxz6f9p4 as LocalTime } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import {
  OffsetDateTime38eu0aw2k27kp as OffsetDateTime,
  OffsetDateTimeIso8601Serializer_getInstance3knxddo24n2p4 as OffsetDateTimeIso8601Serializer_getInstance,
  ZonedDateTime2r72nac52vno4 as ZonedDateTime,
  ZonedDateTimeIso8601Serializer_getInstance3j594qymepbka as ZonedDateTimeIso8601Serializer_getInstance,
} from '../ZonedDateTime.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../lightningserver/files/ServerFile.mjs';
import { ServerFileSerializer_getInstance2y54t0c6enbya as ServerFileSerializer_getInstance } from '../lightningserver/files/ServerFileSerializer.mjs';
import {
  GeoCoordinatemhej4memzolm as GeoCoordinate,
  GeoCoordinateArraySerializer_getInstance1v36ss1z42d62 as GeoCoordinateArraySerializer_getInstance,
} from '../GeoCoordinate.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ClientModule() {
  _init_properties_ClientModule_kt__2waybb();
  return ClientModule;
}
var ClientModule;
function ClientModule$lambda(it) {
  _init_properties_ClientModule_kt__2waybb();
  var tmp = it.q1(0);
  return new (ClosedRangeSerializer())(isInterface(tmp, KSerializer()) ? tmp : THROW_CCE());
}
var properties_initialized_ClientModule_kt_hge9xj;
function _init_properties_ClientModule_kt__2waybb() {
  if (!properties_initialized_ClientModule_kt_hge9xj) {
    properties_initialized_ClientModule_kt_hge9xj = true;
    // Inline function 'kotlinx.serialization.modules.SerializersModule' call
    var builder = new (SerializersModuleBuilder())();
    builder.c1l(getKClass(UUID()), UUIDSerializer_getInstance());
    builder.c1l(getKClass(Instant()), InstantIso8601Serializer_getInstance());
    builder.c1l(getKClass(LocalDate()), LocalDateIso8601Serializer_getInstance());
    builder.c1l(getKClass(LocalTime()), LocalTimeIso8601Serializer_getInstance());
    builder.c1l(getKClass(LocalDateTime()), LocalDateTimeIso8601Serializer_getInstance());
    builder.c1l(getKClass(OffsetDateTime()), OffsetDateTimeIso8601Serializer_getInstance());
    builder.c1l(getKClass(ZonedDateTime()), ZonedDateTimeIso8601Serializer_getInstance());
    builder.c1l(getKClass(Duration()), DurationSerializer_getInstance());
    builder.c1l(getKClass(ServerFile()), ServerFileSerializer_getInstance());
    builder.c1l(getKClass(GeoCoordinate()), GeoCoordinateArraySerializer_getInstance());
    var tmp = getKClass(ClosedRange());
    builder.a1l(tmp, ClientModule$lambda);
    ClientModule = builder.d19();
  }
}
//region block: exports
export {
  get_ClientModule as get_ClientModule2m5j3ywx3t162,
};
//endregion

//# sourceMappingURL=ClientModule.mjs.map
